<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 32, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 32 32"
  fill="none"
  shape-rendering="crispEdges"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <rect x="4" y="6" width="24" height="2" fill="currentColor" />
  <rect x="2" y="10" width="4" height="14" fill="currentColor" />
  <rect x="28" y="10" width="2" height="14" fill="currentColor" />
  <rect x="4" y="12" width="6" height="14" fill="currentColor" />
  <rect x="24" y="12" width="4" height="14" fill="currentColor" />
  <rect x="8" y="14" width="2" height="14" fill="currentColor" />
  <rect x="22" y="14" width="2" height="14" fill="currentColor" />
  <rect x="10" y="14" width="2" height="16" fill="currentColor" />
  <rect x="20" y="14" width="2" height="16" fill="currentColor" />
  <rect x="12" y="16" width="4" height="14" fill="currentColor" />
  <rect x="18" y="16" width="2" height="14" fill="currentColor" />
  <rect x="8" y="4" width="16" height="2" fill="currentColor" />
  <rect x="8" y="8" width="18" height="2" fill="currentColor" />
  <rect x="10" y="2" width="12" height="2" fill="currentColor" />
  <rect x="12" y="10" width="10" height="2" fill="currentColor" />
  <rect x="14" width="4" height="2" fill="currentColor" />
  <rect x="16" y="12" width="2" height="2" fill="currentColor" />
  <rect x="12" y="14" width="2" height="2" fill="currentColor" />
</svg>
